import useMeQuery from "@/hooks/use-me-query";
import { cn } from "@/lib/utils";
import selectUser from "@/utils/select-user";
import copy from "copy-to-clipboard";
import { Send } from "lucide-react";
import { ComponentPropsWithoutRef, forwardRef, MouseEventHandler } from "react";
import { Link } from "react-router";
import { toast } from "sonner";
import { Button } from "./ui/button";

const OpenMeButton = forwardRef<
  HTMLButtonElement,
  Omit<ComponentPropsWithoutRef<typeof Button>, "onClick" | "asChild">
>(({ className, ...props }, ref) => {
  const { data } = useMeQuery();
  const user = selectUser(data);
  const path = user.username
    ? `https://t.me/${encodeURIComponent(user.username)}`
    : "/";

  const handleUsernameError: MouseEventHandler<HTMLButtonElement> = (e) => {
    e.preventDefault();

    if (!user.username) {
      toast.error("Помилка при переході на Telegram", {
        description:
          "У користувача не вказано ім'я користувача у профілі Telegram",
      });
      return;
    }

    copy(`@${import.meta.env.VITE_BOT_NAME} звіт та заміри ${user.id}`);
    window?.open?.(path, "_blank");
  };

  return (
    <Button
      ref={ref}
      className={cn("p-0 aspect-square [&_svg]:size-auto", className)}
      variant="link"
      onClick={handleUsernameError}
      asChild={!!user.username}
      {...props}
    >
      {user.username ? (
        <Link to={path} target="_blank">
          <Send />
        </Link>
      ) : (
        <Send />
      )}
    </Button>
  );
});

export default OpenMeButton;
